import AutoLayout from "../../../../../AutoLayout/AutoLayout";
import React from "react";
import styled from "styled-components";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "../../../../../AutoLayout/AutoLayoutEnums";
import { ITheme } from "../../../../../../Themes/ThemeTypes";

const ImgLogo = styled.img<{ theme: ITheme }>`
  height: 24px;
  width: 24px;
`;

const ResponsiveAutoLayout = styled(AutoLayout)<{ theme: ITheme }>`
  @media (max-width: ${(props) => props.theme.base.responsive.mobile}px) {
    display: none;
  }
`;

interface LogoImageProps {
  appLogoPath: string;
  appName: string;
}

const LogoImage: React.FC<LogoImageProps> = ({ appLogoPath, appName }) => {
  return (
    <ResponsiveAutoLayout
      $direction={AutoLayoutDirectionEnum.HORIZONTAL}
      $align={AutoLayoutAlignEnum.CENTER}
      $horizontalResizing={AutoLayoutResizingEnum.FIXED}
      $verticalResizing={AutoLayoutResizingEnum.FIXED}
      $height={48}
      $width={48}
    >
      <ImgLogo src={appLogoPath} alt={appName} />
    </ResponsiveAutoLayout>
  );
};

export default LogoImage;
